
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CookieService } from '../Services/cookie';
import { AuthService } from '../Services/auth.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-pay-card-failed',
  templateUrl: './pay-card-failed.component.html',
  standalone:false,
  styleUrls: ['./pay-card-failed.component.scss']
})
export class PayCardFailedComponent implements OnInit {
  prodType: string;

  constructor(private router: Router,private route:ActivatedRoute,private cookieService:CookieService,public auth: AuthService) { }
  PaymentID
  responsecode:string;
  ErrorText:string='';
  async ngOnInit(): Promise<void> {


    let P =await this.cookieService.get("prodType", true);
    if (P) {
      this.prodType = P;
    }
//     this.route.queryParams.subscribe(params => {
//       if(params.paymentId){

//         this.PaymentID=params.paymentId;
//       }if(params.failerData){
//         this.responsecode=params.failerData;
//         if(this.responsecode==0o5){
//           // Please contact card issuer
//           this.ErrorText='Your transaction was not complete please contact card issuer'

//         }
//         else if(this.responsecode==14){
//           // Invalid card number
//           this.ErrorText='Your transaction was not complete due to invalid card number'

 
//         }else if(this.responsecode==33||this.responsecode==54){
//           // expired card
//           this.ErrorText='Your transaction was not complete because your card is expired'


//         }else if(this.responsecode==36 || this.responsecode==62){
//           // Restricted card
//           this.ErrorText='Your transaction was not complete because your card is restricted'


//         }else if(this.responsecode==38){
//           // Allowable PIN tries exceeded
//           this.ErrorText='You exceeded maximum number of pin entries'

          
//         }else if(this.responsecode==51){
// // Not sufficient funds
// this.ErrorText='Your transaction was not complete due to insufficient funds'



//         }else if(this.responsecode==55){
//           // Incorrect PIN
//           this.ErrorText='Your transaction was not complete due to incorrect PIN'

          
          
//                   }else if(this.responsecode==61){
//                     // Exceeds withdrawal amount limit
//                     this.ErrorText='Your transaction was not complete due to exceeds withdrawal amount limit'

//                   }else if(this.responsecode==65){

//                     // Exceeds withdrawal frequency limit
//                     this.ErrorText='Your transaction was not complete due to exceeds withdrawal frequency limit'



//                   }else if(this.responsecode==75){
//                     // Allowable number PIN tries exceeded
//                     this.ErrorText='Your transaction was not complete due to allowable number PIN tries exceeded'


//                   }else if(this.responsecode==76){
//                     // Ineligible account
//                     this.ErrorText='Your transaction was not complete due to Ineligible account'


//                   }else if(this.responsecode==78){
//                     // Refer to Issuer
//                     this.ErrorText='Your transaction was not complete it indicates an error or problem from the card issuer'


//                   }else if(this.responsecode==91){
//                     // Issuer is inoperative
//                     this.ErrorText='Your transaction was not complete due to Issuer is inoperative'

//                   }else{
//                     // Your transaction was not complete due to invalid pin
//                     this.ErrorText='Your transaction was not complete something went wrong!'


//                   }

//       }

//     });
 



this.route.queryParams.subscribe(params => {
  if (params['paymentId']) {
    this.PaymentID = params['paymentId'];
  }

  if (params['failerData']) {
    this.responsecode = params['failerData'];

    // Handling response codes based on failerData
    if (this.responsecode === 'BEN-05') {
      // Please contact card issuer
      this.ErrorText = 'Your transaction was not complete, please contact card issuer';
    } else if (this.responsecode === 'BEN-14') {
      // Invalid card number
      this.ErrorText = 'Your transaction was not complete due to an invalid card number';
    } 
    else if (this.responsecode === 'err-invalidReferenceId') {
      // Invalid card number
      this.ErrorText = 'Invalid Reference Id'; 
    }     
    else if (this.responsecode === 'BEN-33' || this.responsecode === 'BEN-54') {
      // Expired card
      this.ErrorText = 'Your transaction was not complete because your card is expired';
    } else if (this.responsecode === 'BEN-36' || this.responsecode === 'BEN-62') {
      // Restricted card
      this.ErrorText = 'Your transaction was not complete because your card is restricted';
    } else if (this.responsecode === 'BEN-38') {
      // Allowable PIN tries exceeded
      this.ErrorText = 'You exceeded the maximum number of pin entries';
    } else if (this.responsecode === 'BEN-51') {
      // Not sufficient funds
      this.ErrorText = 'Your transaction was not complete due to insufficient funds';
    } else if (this.responsecode === 'BEN-55') {
      // Incorrect PIN
      this.ErrorText = 'Your transaction was not complete due to an incorrect PIN';
    } else if (this.responsecode === 'BEN-61') {
      // Exceeds withdrawal amount limit
      this.ErrorText = 'Your transaction was not complete due to exceeding the withdrawal amount limit';
    } else if (this.responsecode === 'BEN-65') {
      // Exceeds withdrawal frequency limit
      this.ErrorText = 'Your transaction was not complete due to exceeding the withdrawal frequency limit';
    } else if (this.responsecode === 'BEN-75') {
      // Allowable number of PIN tries exceeded
      this.ErrorText = 'Your transaction was not complete due to exceeding the allowable number of PIN tries';
    } else if (this.responsecode === 'BEN-76') {
      // Ineligible account
      this.ErrorText = 'Your transaction was not complete due to an ineligible account';
    } else if (this.responsecode === 'BEN-78') {
      // Refer to Issuer
      this.ErrorText = 'Your transaction was not complete due to an issue from the card issuer';
    } else if (this.responsecode === 'BEN-91') {
      // Issuer is inoperative
      this.ErrorText = 'Your transaction was not complete because the issuer is inoperative';
    } else {
      // Generic error message
      this.ErrorText = 'Your transaction was not complete, something went wrong!';
    }
  }
});

}

dashboard(){
  if(this.auth.detailuser)
  {
    this.router.navigateByUrl('/DashboardCreditCards')
  }
  else{
    this.router.navigateByUrl('/LoginWithIdNum')
  }
}

}

